import type { ISearchBarProps } from "../../types";
import { REGISTRATION_NUMBER_LENGTHS } from "../../constants";
import { Button, Card, CardContent, TextField } from "@mui/material";

export default function SearchBar(props: ISearchBarProps) {
  const {
    registrationNumber,
    filteredUsers,
    styles,
    filterUsers,
    handleClearFilteredUsers,
    handleRegistrationNumberChange,
  } = props;

  return (
    <Card sx={styles.cardRoot}>
      <CardContent component="form" onSubmit={filterUsers} sx={styles.searchBarContent}>
        <TextField
          fullWidth
          margin="normal"
          label="Search Registration Number"
          name="input"
          inputProps={{ maxLength: 7 }}
          value={registrationNumber ? registrationNumber : ""}
          onChange={handleRegistrationNumberChange}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!REGISTRATION_NUMBER_LENGTHS.includes(String(registrationNumber).length)}
          sx={styles.searchBarButton}
        >
          Search
        </Button>

        <Button
          variant="contained"
          color="secondary"
          disabled={!filteredUsers.length}
          onClick={handleClearFilteredUsers}
          sx={styles.searchBarButton}
        >
          Clear
        </Button>
      </CardContent>
    </Card>
  );
}
